import { useContext, useMemo } from 'react';

import { ImportStateContext } from '../components/ImportStateContextProvider.tsx';

import type { Doc } from './useUploadReducer.ts';
import type { GoogleDrivePickerDoc } from '../services/GoogleAPIs/GoogleDrivePicker.ts';
import type { OneDriveFileType } from '../services/OneDriveAPIs/OneDriveTypes.ts';

const getSelectedDocuments = (docs: Doc[]) => docs.filter((doc) => doc.selected);
const getDocumentsToUpload = (docs: Doc[]) => docs.map((doc) => doc.document);

export const useGetSelectedDocuments = (): {
	selectedDocuments: Doc[];
	documentsToUpload: (GoogleDrivePickerDoc | File | OneDriveFileType)[];
} => {
	const { docs } = useContext(ImportStateContext);
	const selectedDocuments = useMemo(() => getSelectedDocuments(docs), [docs]);
	const documentsToUpload = useMemo(
		() => getDocumentsToUpload(selectedDocuments),
		[selectedDocuments],
	);
	return {
		selectedDocuments,
		documentsToUpload,
	};
};
